import { atom, type Atom } from "jotai";
import type { ComponentName, ComponentState } from "app/componentOptions";
import type { ComponentController } from "lib/util/ComponentController";

export type ComponentStackEntry = {
  componentAtom: Atom<ComponentState<ComponentName>>;
  controller: ComponentController;
};

export type ComponentStack = ComponentStackEntry[];

const componentStackAtom = atom<ComponentStack>([]);

export default componentStackAtom;
